export default "__VITE_ASSET__Czm6$Q$a__"